import pxToRem from "../../functions/pxToRem";

export default function tab({ typography, borders, colors }) {
  const { size, fontWeightRegular } = typography;
  const { borderRadius } = borders;
  const { text } = colors;

  const tab = {
    styleOverrides: {
      root: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flex: "1 1 auto",
        textAlign: "center",
        maxWidth: "unset !important",
        minWidth: "unset !important",
        minHeight: "unset !important",
        fontSize: size.md,
        fontWeight: fontWeightRegular,
        textTransform: "none",
        lineHeight: "inherit",
        padding: pxToRem(4),
        borderRadius: borderRadius.lg,
        color: `${text.primary} !important`,
        opacity: "1 !important",

        "& .material-icons, .material-icons-round": {
          marginBottom: "0 !important",
          marginRight: pxToRem(6),
        },

        "& svg": {
          marginBottom: "0 !important",
          marginRight: pxToRem(6),
        },
      },

      labelIcon: {
        paddingTop: pxToRem(4),
      },
    },
  };

  return tab;
}
